import { menu } from "../interface/menu-interface";
import { userPermission } from "../interface/user";
import { UrlServices } from "./url-services";

export const MENU_ITEMS: menu[] = [
    {
        title: 'Dashboard',
        icon: 'pi pi-home',
        link: UrlServices.DASHBOARD_ROUTE,
        data: { permission: {} as userPermission },
    },
    {
        title: 'Institution',
        link: UrlServices.PAGE_URL.SCHOOL.LIST.URL,
        icon: 'pi pi-building',
        data: { permission: UrlServices.PAGE_URL["SCHOOL"]["LIST"].permission },
    },
    {
        title: 'Staff',
        icon: 'pi pi-users',
        link: UrlServices.PAGE_URL.STAFF.LIST.URL,
        data: { permission: UrlServices.PAGE_URL["STAFF"]["LIST"].permission }
    },
    // {
    //     title: 'Staff Attendance',
    //     icon: 'pi pi-book',
    //     link: UrlServices.PAGE_URL.ATTENDANCE.VIEW.URL,
    //     data: { permission: UrlServices.PAGE_URL["ATTENDANCE"]["VIEW"].permission },
    // data: { permission: {} as userPermission },
    // children: [
    // {
    //     title: 'Attendance List',
    //     link: UrlServices.PAGE_URL.ATTENDANCE.LIST.URL,
    //     data: { permission: {} as userPermission },
    // },
    // {
    //     title: 'New Attendance',
    //     link: UrlServices.PAGE_URL.ATTENDANCE.ADD.URL,
    //     data: { permission: {} as userPermission },
    // },
    //     {
    //         title: 'Attendance Mangement',
    //         link: UrlServices.PAGE_URL.ATTENDANCE.VIEW.URL,
    //         data: { permission: {} as userPermission },
    //     },
    // ]
    // },
    {
        title: 'Student',
        icon: 'icon-graduation',
        data: { permission: {} as userPermission },
        children: [
            {
                title: 'All Students',
                link: UrlServices.PAGE_URL.STUDENT.LIST.URL,
                // data: { permission: {} as userPermission },
                data: { permission: UrlServices.PAGE_URL["STUDENT"]["LIST"].permission },
            },
            {
                title: 'Student Fees Details',
                link: UrlServices.PAGE_URL.STUDENT.Details.URL,
                data: { permission: UrlServices.PAGE_URL["STUDENT"]["Details"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'Student Promotion',
                link: UrlServices.PAGE_URL.STUDENT.PROMOTION.URL,
                data: { permission: UrlServices.PAGE_URL["STUDENT"]["PROMOTION"].permission },
                // data: { permission: {} as userPermission },
            },
            // {
            //     title: '',
            //     link: UrlServices.PAGE_URL.STUDENT.PROFILE.URL,
            //     data: { permission: {} as userPermission },
            // },
        ],
    },

    {
        title: 'Fees Collection',
        icon: 'pi pi-wallet',
        // data: { permission: {} as userPermission },
        children: [
            {
                title: 'Receipt',
                link: UrlServices.PAGE_URL.FEESCOLLECTION.LIST.URL,
                data: { permission: UrlServices.PAGE_URL["FEESCOLLECTION"]["LIST"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'New Collection',
                link: UrlServices.PAGE_URL.FEESCOLLECTION.VIEW.URL,
                // data: { permission: {} as userPermission },
                data: { permission: UrlServices.PAGE_URL["FEESCOLLECTION"]["VIEW"].permission },
            },
            {
                title: 'Add Fees',
                link: UrlServices.PAGE_URL.FEESCOLLECTION.ADDFEES.URL,
                data: { permission: UrlServices.PAGE_URL["FEESCOLLECTION"]["ADDFEES"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'Other Fees',
                link: UrlServices.PAGE_URL.FEESCOLLECTION.PAYFEES.URL,
                data: { permission: UrlServices.PAGE_URL["FEESCOLLECTION"]["PAYFEES"].permission },

                // data: { permission: {} as userPermission },
            },
            {
                title: 'Bulk Fees',
                link: UrlServices.PAGE_URL.FEESCOLLECTION.BULK_FEES_LIST.URL,
                data: { permission: UrlServices.PAGE_URL["FEESCOLLECTION"]["BULK_FEES_LIST"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'Pending Fees',
                link: UrlServices.PAGE_URL.FEESCOLLECTION.PENDING_LIST.URL,
                data: { permission: UrlServices.PAGE_URL["FEESCOLLECTION"]["PENDING_LIST"].permission },
            },
        ]
    },
    {
        title: 'Reports',
        icon: 'pi pi-database',
        // data: { permission: {} as userPermission },
        children: [
            {
                title: 'Student Reports',
                link: UrlServices.PAGE_URL.REPORT.LIST.URL,
                data: { permission: UrlServices.PAGE_URL["REPORT"]["LIST"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'Institution Reports',
                link: UrlServices.PAGE_URL.REPORT.ADD.URL,
                data: { permission: UrlServices.PAGE_URL["REPORT"]["ADD"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'Invoice Reports',
                link: UrlServices.PAGE_URL.REPORT.VIEW.URL,
                data: { permission: UrlServices.PAGE_URL["REPORT"]["VIEW"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'Collection Reports',
                link: UrlServices.PAGE_URL.REPORT.COLLECTION.URL,
                data: { permission: UrlServices.PAGE_URL["REPORT"]["VIEW"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'Discount Reports',
                link: UrlServices.PAGE_URL.REPORT.DISCOUNT.URL,
                data: { permission: UrlServices.PAGE_URL["REPORT"]["VIEW"].permission },
            },
        ]
    },

    {
        title: 'Device Management',
        icon: 'pi pi-database',
        link: UrlServices.PAGE_URL.DEVICE_MANAGEMENT.LIST.URL,
        data: { permission: UrlServices.PAGE_URL["DEVICE_MANAGEMENT"]["LIST"].permission },
    },

    {
        title: 'User',
        icon: 'pi pi-user',
        // data: { permission: UrlServices.PAGE_URL["USER"]["VIEW_ALL"].permission },
        // data: { permission: {} as userPermission },
        children: [
            {
                title: 'User',
                link: UrlServices.PAGE_URL.USER.LIST.URL,
                data: { permission: UrlServices.PAGE_URL["USER"]["LIST"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'Role',
                link: UrlServices.PAGE_URL.USER.ROLE.URL,
                data: { permission: UrlServices.PAGE_URL["USER"]["ROLE"].permission },
                // data: { permission: {} as userPermission },
            },
        ]
    },
    {
        title: 'Master',
        icon: 'pi pi-cog',
        // data: { permission: {} as userPermission },
        children: [
            {
                title: 'Settings',
                link: UrlServices.PAGE_URL.MASTER.GENERAL.URL,
                data: { permission: UrlServices.PAGE_URL["MASTER"]["FEES"].permission },
                // data: { permission: {} as userPermission },
            },
            // {
            //     title: 'Office',
            //     link: UrlServices.PAGE_URL.USER.LIST.URL,
            //     data: { permission: {} as userPermission },
            // },
            {
                title: 'Fees',
                link: UrlServices.PAGE_URL.MASTER.FEES.URL,
                data: { permission: UrlServices.PAGE_URL["MASTER"]["FEES"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'Notice Board',
                link: UrlServices.PAGE_URL.MASTER.NOTICE.URL,
                data: { permission: UrlServices.PAGE_URL["MASTER"]["FEES"].permission },
                // data: { permission: {} as userPermission },
            },
            {
                title: 'Message Log',
                link: UrlServices.PAGE_URL.MASTER.LOG.URL,
                data: { permission: UrlServices.PAGE_URL["MASTER"]["FEES"].permission },
            },
        ]
    },
    // {
    //     title: 'Manage Leave ',
    //     icon: ' icon-support',
    //     link: UrlServices.PAGE_URL.LEAVEPOLICY.LIST.URL,
    //     // link: UrlServices.PAGE_URL.ATTENDANCE.LIST.URL,

    //     data: { permission: {} as userPermission },

    //   },

];
